module.exports = __webpack_public_path__ + "static/kitchen-square.5f384cb9.jpg";